import { initCopySkuHandler } from '../shared/copy-sku';

initCopySkuHandler('.wps-product-card__copy');
